import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Lock } from "lucide-react";

export default function Navbar({ onSaveSpot }) {
  const [open, setOpen] = useState(false);

  return (
    <nav
      data-testid="public-navbar"
      className="fixed top-11 md:top-12 inset-x-0 z-50 backdrop-blur-xl bg-[#0A1128]/85 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src="/ssu-logo.png" alt="SSU Workshops" className="h-14 md:h-16 w-auto" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-white text-base tracking-tight">
              SSU <span className="text-[#FACC15]">WORKSHOPS</span>
            </span>
            <span className="text-[9px] tracking-[0.25em] text-white/50 uppercase mt-0.5">Members Only</span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-7">
          <a
            href="/#estate"
            data-testid="navbar-estate"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            The Estate
          </a>
          <a
            href="/#schedule"
            data-testid="navbar-schedule"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            Schedule
          </a>
          <a
            href="/#speakers"
            data-testid="navbar-speakers"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            Speakers
          </a>
          <a
            href="https://www.skool.com/superheroswimuniversity/about"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-join-community"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            Join Community
          </a>
          <Link
            to="/sponsor"
            data-testid="navbar-sponsor"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            Sponsor
          </Link>
          <Link
            to="/waiver"
            data-testid="navbar-waiver"
            className="text-sm font-semibold text-white/80 hover:text-[#FACC15] tracking-wide uppercase transition-colors"
          >
            Waiver
          </Link>
          <Link
            to="/admin/login"
            data-testid="navbar-admin"
            className="text-xs font-semibold text-white/50 hover:text-[#FACC15] tracking-wide uppercase transition-colors inline-flex items-center gap-1.5"
            title="Admin login"
          >
            <Lock size={12} /> Admin
          </Link>
          <button
            data-testid="navbar-save-spot"
            onClick={onSaveSpot}
            className="btn-shine bg-[#FACC15] hover:bg-[#EAB308] text-[#0A1128] text-sm font-black tracking-wider uppercase px-5 py-2.5 rounded-md transition-colors"
          >
            Get Tickets
          </button>
        </div>

        <button
          data-testid="navbar-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A1128] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          <a
            href="/#estate"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-estate"
            onClick={() => setOpen(false)}
          >
            The Estate
          </a>
          <a
            href="/#schedule"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-schedule"
            onClick={() => setOpen(false)}
          >
            Schedule
          </a>
          <a
            href="/#speakers"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-speakers"
            onClick={() => setOpen(false)}
          >
            Speakers
          </a>
          <a
            href="https://www.skool.com/superheroswimuniversity/about"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-join-community"
            onClick={() => setOpen(false)}
          >
            Join Community
          </a>
          <Link
            to="/sponsor"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-sponsor"
            onClick={() => setOpen(false)}
          >
            Sponsor
          </Link>
          <Link
            to="/waiver"
            className="text-sm font-semibold text-white/90 uppercase tracking-wide"
            data-testid="navbar-mobile-waiver"
            onClick={() => setOpen(false)}
          >
            Waiver
          </Link>
          <Link
            to="/admin/login"
            className="text-sm font-semibold text-white/70 uppercase tracking-wide inline-flex items-center gap-1.5"
            data-testid="navbar-mobile-admin"
            onClick={() => setOpen(false)}
          >
            <Lock size={12} /> Admin Login
          </Link>
          <button
            data-testid="navbar-mobile-save-spot"
            onClick={() => { setOpen(false); onSaveSpot && onSaveSpot(); }}
            className="bg-[#FACC15] text-[#0A1128] text-sm font-black uppercase tracking-wider px-5 py-2.5 rounded-md text-left"
          >
            Get Tickets
          </button>
        </div>
      )}
    </nav>
  );
}
